import React, { useEffect, useState } from "react";
import { Avatar, Box, Checkbox, Divider, Grid, Typography } from "@mui/material";
import { LeaverTask } from "../LeaverCard";
import { Button } from "component/MarketPlace/ButtonComponents";

export interface IPropsCheckList {
  initList: LeaverTask[];
  handleSubmitTask: (list: LeaverTask[]) => void;
  locale: any;
}

const CheckList = (props: IPropsCheckList) => {
  const { initList, handleSubmitTask, locale } = props;

  const [list, setList] = useState<LeaverTask[]>(initList);

  const handleToggleCompletedManage = (e: any) => {
    const newList = list?.map((item: any) => {
      if (item?.offboarding_task_id === e.target.name) {
        return { ...item, active: e.target.checked };
      } else {
        return item;
      }
    });
    setList(newList);
  };

  const handleToggleCompletedAllManage = (e: any) => {
    const newList = list?.map((item) => {
      return { ...item, active: e.target.checked };
    });
    setList(newList);
  };

  useEffect(() => {
    setList(initList);
  }, [initList]);

  return (
    <>
      <Box>
        <Grid container>
          <Grid item xs={8} sx={{ margin: 'auto' }}>
            <Typography>{locale?.checkList?.title}</Typography>
          </Grid>
          <Grid item xs={4} sx={{ margin: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
            <Typography sx={{ display: 'flex', alignItems: 'center' }}>{locale?.checkList?.checkBoxSelect}</Typography>
            <Checkbox
              checked={list?.every((item) => item.active === true)}
              onChange={handleToggleCompletedAllManage}
            ></Checkbox>
          </Grid>
        </Grid>
        <Divider />
      </Box>
      <Box>
        {list?.length > 0 ? (
          list?.map((task) => {
            return (
              <Box key={task.offboarding_task_id}>

                <Grid container py={3}>
                  <Grid item xs={8} sx={{ display: 'flex' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar alt={task.name} src={task.picture} sx={{ margin: 'auto', marginRight: '16px' }} />
                    </Box>
                    <Box paddingTop="8px">
                      <Typography variant="h6">
                        {task.name}
                      </Typography>
                      {task.description && (
                        <Typography variant="subtitle1">
                          {`${locale?.checkList?.description}: ${task.description}`}
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ margin: 'auto', textAlign: 'end' }}
                  >
                    <Checkbox
                      name={task.offboarding_task_id}
                      checked={task?.active}
                      onChange={handleToggleCompletedManage}
                    ></Checkbox>
                  </Grid>
                </Grid>
                <Divider />
              </Box>
            )
          })
        ) : (
          <>{locale?.checkList?.noTasks}</>
        )}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: '-24px', mt: '24px' }}>
        <Button
          onClick={() => handleSubmitTask(list)}
          variant="text"
          size="medium"
        >
          {locale?.checkList?.btnOk}
        </Button>
      </Box>
    </>
  )
};

export default CheckList;